/* eslint-disable react/jsx-props-no-spreading */
import React, { forwardRef } from 'react';
import { Form, InputGroup } from 'rsuite';
import { FormFieldSize } from 'components/Form/CustomForm/CustomForm';
import FormControlLabel from '../../../Control/FormControlLabel';
// eslint-disable-next-line import/no-unresolved
import styles from './TextFormField.module.scss';

interface ITextFormField {
  required: boolean;
  size: FormFieldSize;
  disabled?: boolean;
  name: string; // name of the key to map to
  label: string; // field label
  type: 'text' | 'email' | 'number' | 'password';
  helpMessage?: string; // help message to display
  placeholder?: string; // field placeholder
  checkAsync?: boolean; // true if we need to perform async checks on form field
  className?: any; // custom class name for form field group
}

/**
 * Renders text from field
 */
export const TextFormField = forwardRef(
  (props: ITextFormField, ref: any) => {
    const {
      size,
      disabled = undefined,
      checkAsync = false,
      placeholder = '',
      name,
      helpMessage = undefined,
      label,
      required,
      className = undefined,
      ...rest
    } = props;

    return (
      <Form.Group
        ref={ref}
        style={{ flex: 1 }}
        className={[
          styles.formGroup,
          size === 'sm' ? styles.sm : styles.lg,
          className,
        ]
          .filter(Boolean)
          .join(' ')}
      >
        <FormControlLabel required={required || false}>
          {label}{' '}
        </FormControlLabel>
        <div className={styles.controlWrapper}>
          {checkAsync ? (
            <Form.Control
              disabled={disabled || false}
              checkAsync
              placeholder={placeholder}
              name={name}
              acceptor={InputGroup}
              {...rest}
            />
          ) : (
            <Form.Control
              disabled={disabled || false}
              placeholder={placeholder}
              name={name}
              acceptor={InputGroup}
              {...rest}
            />
          )}
          {helpMessage ? (
            <Form.HelpText>{helpMessage}</Form.HelpText>
          ) : null}
        </div>
      </Form.Group>
    );
  },
);

export default TextFormField;
